import {useMutation, useQuery} from "react-query";
import {getAxios, postFormAxios} from "../../axios/generic-api-calls";
import {queryClient} from "../../App";
import {AxiosError} from "axios";
import {LateGroupJoinModel, LateGroupModel} from "./lateGroupTypes";


export function useJoinLateGroup() {
    return useMutation<LateGroupJoinModel, AxiosError, LateGroupJoinModel>((lateGroupData) => postFormAxios(`/late-group/${lateGroupData.round_id}`, lateGroupData),
        {
            onSuccess: async (lateGroupData) => {
                await queryClient.invalidateQueries('lateGroup.currentUser');
                await queryClient.invalidateQueries(`late_groups.${lateGroupData.round_id}`);
            },
        },
    );
}

export function useFetchLateGroups(roundId: number,key:string = `late_groups.${roundId}`) {
    return useQuery<LateGroupModel>(key,() => getAxios(`/late-group-table/${roundId}`));
}
